// 인라인 구현이 좀 맘에 안들기는 하는데 뭐 어쩔수가 없다;
import {Directive, ElementRef, Renderer, HostListener} from '@angular/core';

@Directive({
    selector: '[AutoResize]'
})

export class AutoResizeDirective {
    @HostListener('input', ['$event.target'])

    onInput(): void {
        this.resizeTextarea();
    }
    constructor(
        public element: ElementRef,
        private renderer : Renderer,
    ){ }

    ngAfterContentChecked(): void {
        this.resizeTextarea();
    }

    resizeTextarea(): void{
        this.element.nativeElement.style.overflow = 'hidden';
        this.element.nativeElement.style.height = 'auto';
        this.element.nativeElement.style.height = this.element.nativeElement.scrollHeight + "px";
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/form-auto-resize/ng-form-auto-resize.directive.ts